import React from 'react'
import {
  Switch,
  Redirect,
} from 'react-router-dom'

import PaneRoute from './PaneRoute'
import MonthlySavings from './MonthlySavings'
import MonthlyExpenses from './MonthlyExpenses'
import AnnualExpenses from './AnnualExpenses'
import Income from './Income'

export default (props) => (
  <div style={styles.container}>
    <Switch>
      <PaneRoute exact path='/monthly-savings' component={MonthlySavings} childrenProps={props} />
      <PaneRoute exact path='/monthly-expenses' component={MonthlyExpenses} childrenProps={props} />
      <PaneRoute exact path='/annual-expenses' component={AnnualExpenses} childrenProps={props} />
      <PaneRoute exact path='/income' component={Income} childrenProps={props} />
      <Redirect from='/' to='/income' />
    </Switch>
  </div>
)

const styles = {
  container: {
    padding: '0 20px',
    width: '100%',
    boxSizing: 'border-box',
  },
}
